import Session from './session'
import { Paths } from 'utils/paths'
import { ioFetch } from 'utils/ajax'

const Welcome = {}

// Dismiss the welcome page for the current user
Welcome.dismiss = () => (dispatch, getState) => {
  const
    client = Session.getAuthenticatedClient(dispatch, getState),
    user = getState().session.user

  if (!client || !user) {
    return Promise.reject('User not authenticated')
  }

  return ioFetch(
    Paths.api_welcome_dismiss({ username: user.username }),
    {
      headers: { 'Authorization': `Bearer ${client.jwt}` },
      method: 'POST'
    }
  ).then(() => {
    // Update profile to reflect dismissed state
    const profile = getState().profiles.current
    if (profile) {
      dispatch({
        type: 'PROFILE_LOAD_FULFILLED',
        payload: {
          ...profile,
          should_see_welcome: false
        }
      })
    }
  })
}

export default Welcome
